import { FC, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PosLayout } from "../../../components";
import { PosInnerPageLayout } from "../../../components/layouts/pos-layout/PosInnerPageLayout";
import ManagerCodeModal from "../../../components/common/manager-code-modal/ManagerCodeModal";
import { PinTagBoxes } from "../../../components/common/pintag-boxes/pin-tag-boxes";
import { PinTagBooks } from "../../../components/common/pintag-boxes/pin-tag-books";
import { Colors } from "../../../configs";
import { useAppSelector } from "../../../hooks";

type View = "boxes" | "books";

// POS manager page for pin tag boxes (reported issues 3.p.ii) and their
// books: behind the manager PIN, and the approving manager is recorded as
// the box's opener / the book's releaser
export const PinTagBoxesPage: FC = () => {
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.auth);
  const [managerId, setManagerId] = useState<number | undefined>();
  const [approved, setApproved] = useState(false);
  const [view, setView] = useState<View>("boxes");

  return (
    <PosLayout>
      <>
        <PosInnerPageLayout
          title="Pin Tag Boxes"
          onClickBack={() => navigate("/pos/lobby")}
        >
          {approved && (
            // Scrolls inside the page when the books run past the screen
            <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", pb: "2rem" }}>
              <Box
                sx={{
                  backgroundColor: Colors.WHITE,
                  padding: "2rem",
                  borderRadius: "0.71rem",
                  margin: "0 auto",
                  width: "100%",
                  maxWidth: "130rem",
                }}
              >
                <Tabs
                  value={view}
                  onChange={(_, next: View) => setView(next)}
                  aria-label="Pin tag boxes view"
                  sx={{ mb: "1.5rem", borderBottom: "1px solid #E5E7EB" }}
                >
                  <Tab value="boxes" label="Boxes" sx={{ fontSize: "var(--fs-base)", textTransform: "none" }} />
                  <Tab value="books" label="Books" sx={{ fontSize: "var(--fs-base)", textTransform: "none" }} />
                </Tabs>
                {view === "boxes" ? (
                  <PinTagBoxes openedByUserId={managerId} />
                ) : (
                  <PinTagBooks releasedByUserId={managerId} />
                )}
              </Box>
            </Box>
          )}
        </PosInnerPageLayout>
        <ManagerCodeModal
          open={!approved}
          onClose={() => navigate("/pos/lobby")}
          title="Pin Tag Boxes"
          task="to manage pin tag boxes and books"
          onDone={(id) => {
            setManagerId(id);
            setApproved(true);
          }}
          requestedByUserId={user?.id}
          actionType="PINTAG_BOX_ACCESS"
        />
      </>
    </PosLayout>
  );
};
